// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* أنماط طباعة الفاتورة — ملف واحد للتحكم */
@media print {
  @page {
    margin: 6mm;
    size: A4 portrait;
  }

  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: auto !important;
    background: white !important;
    overflow: visible !important;
  }

  body:has(.invoice-modal-print) > *:not(.invoice-modal-print) {
    display: none !important;
  }

  .print\\:hidden,
  .no-print {
    display: none !important;
  }

  .invoice-modal-print,
  .invoice-modal-print > div,
  .invoice-modal-print > div > div:last-child,
  .invoice-modal-print .inline-block {
    display: block !important;
    position: static !important;
    width: 100% !important;
    max-width: none !important;
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 0 !important;
    transform: none !important;
    overflow: visible !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    background: white !important;
    text-align: right !important;
  }

  .invoice-modal-print [class*='translate'] {
    transform: none !important;
    translate: none !important;
  }

  .invoice-container {
    display: block !important;
    position: static !important;
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    box-shadow: none !important;
    border: none !important;
    print-color-adjust: exact;
  }

  .invoice-themed {
    width: 100% !important;
    min-height: 0 !important;
    padding: 5px !important;
    box-sizing: border-box !important;
    background: #0c1835 !important;
  }

  .invoice-frame,
  .invoice-sheet {
    width: 100% !important;
    min-height: 0 !important;
    overflow: hidden !important;
    border-radius: 0 !important;
  }

  .invoice-sheet {
    display: block !important;
  }

  /* الهيدر — بانر كامل + محتوى مرتب فوقه بثلاث أعمدة */
  .invoice-header-themed {
    display: grid !important;
    grid-template-columns: 1fr !important;
    grid-template-rows: 1fr !important;
    position: relative !important;
    overflow: visible !important;
    background: #0c1835 !important;
    box-sizing: border-box !important;
  }

  .invoice-header-bg {
    grid-column: 1 !important;
    grid-row: 1 !important;
    display: block !important;
    width: 100% !important;
    height: auto !important;
    max-height: none !important;
    object-fit: contain !important;
    object-position: top center !important;
    align-self: start !important;
  }

  .invoice-header-content {
    grid-column: 1 !important;
    grid-row: 1 !important;
    position: relative !important;
    inset: auto !important;
    align-self: start !important;
    width: 100% !important;
    padding: 12px 12px 14px !important;
    box-sizing: border-box !important;
    overflow: visible !important;
    z-index: 2 !important;
    direction: rtl !important;

    /* ═══ يمين ويسار الهيدر — عدّل هنا ═══ */
    /* موضع الكتلة كاملة (شعار + نص تحته) */
    --print-header-right-x: 60px;  /* يمين: سالب ← لليمين | موجب → للوسط */
    --print-header-left-x: -60px;   /* يسار: سالب → لليسار | موجب ← للوسط */
    --print-header-side-icon-size: 75px;
    --print-header-side-icon-y: 10px;      /* رفع/نزول الأيقونة */
    --print-header-side-icon-gap: 4px;
    --print-header-side-text-size: 13px;
    --print-header-side-text-line: 1.7;
    --print-header-side-text-gap: 3px;

    /* ═══ وسط الهيدر: شعار الشركة ═══ */
    --print-company-logo-x: 0px;
    --print-company-logo-y: 10px;
  }

  .invoice-header-row {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr) minmax(0, 1fr) !important;
    align-items: start !important;
    justify-content: stretch !important;
    gap: 2px !important;
    width: 100% !important;
  }

  .invoice-header-row > div {
    display: flex !important;
    flex-direction: column !important;
    min-width: 0 !important;
  }

  /* يمين ويسار — الأيقونة فوق النص بالوسط (مو عند الحافة) */
  .invoice-header-row > div:first-child,
  .invoice-header-row > div:last-child {
    justify-self: stretch !important;
    align-items: center !important;
    text-align: center !important;
    margin-inline: 0 !important;
  }

  .invoice-header-row > div:first-child > div {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    width: 100% !important;
    transform: translateX(var(--print-header-right-x)) !important;
  }

  .invoice-header-row > div:last-child > div {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    width: 100% !important;
    transform: translateX(var(--print-header-left-x)) !important;
  }

  .invoice-header-row > div:nth-child(2) {
    justify-self: center !important;
    align-items: center !important;
    text-align: center !important;
  }

  .invoice-header-row > div:nth-child(2) > .drop-shadow-sm {
    display: flex !important;
    justify-content: center !important;
    width: 100% !important;
    text-align: center !important;
  }

  .invoice-company-title {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
    width: 100% !important;
  }

  .invoice-company-office-row {
    display: inline-flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;
  }

  .invoice-header-vision-slot,
  .invoice-header-qr-slot {
    display: flex !important;
    justify-content: center !important;
    align-self: center !important;
    margin-inline: auto !important;
    margin-bottom: var(--print-header-side-icon-gap) !important;
    margin-top: var(--print-header-side-icon-y) !important;
    transform: none !important;
  }

  .invoice-header-ksa-logo,
  .invoice-header-qr-box {
    width: var(--print-header-side-icon-size) !important;
    height: var(--print-header-side-icon-size) !important;
  }

  .invoice-header-vision-slot {
    transform: none !important;
  }

  .invoice-header-company-logo {
    width: 140px !important;
    height: 140px !important;
    margin-inline: auto !important;
    margin-bottom: 6px !important;
    margin-top: var(--print-company-logo-y) !important;
    transform: translateX(var(--print-company-logo-x)) !important;
  }

  .invoice-header-licenses,
  .invoice-header-meta {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    align-self: center !important;
    width: 100% !important;
    margin-inline: 0 !important;
    text-align: center !important;
    transform: none !important;
  }

  .invoice-header-licenses .flex,
  .invoice-header-meta .flex {
    align-items: center !important;
    text-align: center !important;
  }

  .invoice-header-licenses > * + *,
  .invoice-header-meta > * + * {
    margin-top: var(--print-header-side-text-gap) !important;
  }

  .invoice-header-licenses .invoice-license-label,
  .invoice-header-meta .invoice-license-label {
    font-size: var(--print-header-side-text-size) !important;
    line-height: var(--print-header-side-text-line) !important;
  }

  .invoice-header-licenses .invoice-license-value,
  .invoice-header-licenses .invoice-license-value span,
  .invoice-header-meta .invoice-license-value,
  .invoice-header-meta .invoice-license-value span {
    font-size: var(--print-header-side-text-size) !important;
    line-height: var(--print-header-side-text-line) !important;
  }

  .invoice-company-gold {
    font-size: 25px !important;
    font-weight: 700 !important;
    line-height: 1.25 !important;
    text-align: center !important;
  }

  .invoice-company-name {
    font-size: 2rem !important;
    font-weight: 700 !important;
    line-height: 1.25 !important;
    color: #111827 !important;
    text-align: center !important;
  }

  .invoice-company-line {
    width: 2rem !important;
  }

  .invoice-body-panel::before {
    display: none !important;
  }

  .invoice-body-panel {
    flex: none !important;
    display: block !important;
  }

  .invoice-body {
    padding: 10px 14px 12px !important;
    background: transparent !important;
  }

  .invoice-section-block {
    margin-bottom: 8px !important;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .invoice-section-title-row {
    margin-bottom: 4px !important;
  }

  .invoice-section-title {
    font-size: 0.9rem !important;
  }

  .invoice-title-icon-box {
    width: 1.75rem !important;
    height: 1.75rem !important;
  }

  .invoice-title-icon {
    width: 1rem !important;
    height: 1rem !important;
  }

  .invoice-section-frame {
    padding: 6px 10px !important;
    border: 1px solid #c9a227 !important;
    background: transparent !important;
  }

  .invoice-stacked-field {
    padding: 4px 6px !important;
  }

  .invoice-stacked-field span {
    font-size: 0.75rem !important;
    line-height: 1.25 !important;
  }

  .invoice-route-block {
    padding: 6px 8px !important;
  }

  .invoice-route-row {
    column-gap: 0.3rem !important;
  }

  .invoice-route-meta span,
  .invoice-route-city {
    font-size: 0.75rem !important;
  }

  .invoice-body .text-lg,
  .invoice-body .text-base {
    font-size: 0.8rem !important;
    line-height: 1.3 !important;
  }

  .invoice-inner-divider {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }

  .invoice-amount-row {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }

  .invoice-amount-row span {
    font-size: 0.8rem !important;
  }

  .invoice-footer {
    padding-top: 6px !important;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .invoice-footer-grid {
    display: grid !important;
    grid-template-columns: 1fr 1px 1fr 1px 1fr !important;
  }

  .invoice-footer-cell {
    font-size: 0.75rem !important;
    padding-inline: 6px !important;
  }

  .invoice-footer-qr {
    width: 4rem !important;
    height: 4rem !important;
  }

  .invoice-container .invoice-license-label {
    color: #b8860b !important;
  }

  .invoice-container .text-orange-600 {
    color: #ea580c !important;
  }

  .invoice-title-icon,
  .invoice-company-gold {
    color: #c9a227 !important;
  }

  .invoice-company-name {
    color: #111827 !important;
  }

  .invoice-company-line {
    background: #c9a227 !important;
  }

  .invoice-footer {
    border-top: 1px solid #c9a227 !important;
  }

  .invoice-footer-divider {
    background: #c9a227 !important;
  }

  .invoice-container,
  .invoice-container * {
    print-color-adjust: exact;
  }

  ::-webkit-scrollbar {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Invoice/invoice-print.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;;IAEE,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;;;IAIE,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IAEvB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;IACvB,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qDAAqD;EACrD;IACE,wBAAwB;IACxB,qCAAqC;IACrC,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;IAC5B,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,kCAAkC;IAClC,iCAAiC;IACjC,4BAA4B;IAC5B,qBAAqB;IACrB,yBAAyB;;IAEzB,yCAAyC;IACzC,uCAAuC;IACvC,4BAA4B,GAAG,uCAAuC;IACtE,4BAA4B,IAAI,uCAAuC;IACvE,mCAAmC;IACnC,gCAAgC,OAAO,sBAAsB;IAC7D,iCAAiC;IACjC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;;IAEjC,oCAAoC;IACpC,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,gFAAgF;IAChF,6BAA6B;IAC7B,mCAAmC;IACnC,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA,0DAA0D;EAC1D;;IAEE,gCAAgC;IAChC,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,sBAAsB;IACtB,6DAA6D;EAC/D;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,sBAAsB;IACtB,4DAA4D;EAC9D;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;IAClC,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;;IAEE,wBAAwB;IACxB,kCAAkC;IAClC,6BAA6B;IAC7B,8BAA8B;IAC9B,2DAA2D;IAC3D,sDAAsD;IACtD,0BAA0B;EAC5B;;EAEA;;IAEE,oDAAoD;IACpD,qDAAqD;EACvD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,6BAA6B;IAC7B,kDAAkD;IAClD,6DAA6D;EAC/D;;EAEA;;IAEE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;;IAEE,wDAAwD;EAC1D;;EAEA;;IAEE,wDAAwD;IACxD,0DAA0D;EAC5D;;EAEA;;;;IAIE,wDAAwD;IACxD,0DAA0D;EAC5D;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,qDAAqD;EACvD;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAGE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* أنماط طباعة الفاتورة — ملف واحد للتحكم */\n@media print {\n  @page {\n    margin: 6mm;\n    size: A4 portrait;\n  }\n\n  html,\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    height: auto !important;\n    background: white !important;\n    overflow: visible !important;\n  }\n\n  body:has(.invoice-modal-print) > *:not(.invoice-modal-print) {\n    display: none !important;\n  }\n\n  .print\\:hidden,\n  .no-print {\n    display: none !important;\n  }\n\n  .invoice-modal-print,\n  .invoice-modal-print > div,\n  .invoice-modal-print > div > div:last-child,\n  .invoice-modal-print .inline-block {\n    display: block !important;\n    position: static !important;\n    width: 100% !important;\n    max-width: none !important;\n    height: auto !important;\n    min-height: 0 !important;\n    max-height: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    transform: none !important;\n    overflow: visible !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n    background: white !important;\n    text-align: right !important;\n  }\n\n  .invoice-modal-print [class*='translate'] {\n    transform: none !important;\n    translate: none !important;\n  }\n\n  .invoice-container {\n    display: block !important;\n    position: static !important;\n    width: 100% !important;\n    max-width: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    box-shadow: none !important;\n    border: none !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .invoice-themed {\n    width: 100% !important;\n    min-height: 0 !important;\n    padding: 5px !important;\n    box-sizing: border-box !important;\n    background: #0c1835 !important;\n  }\n\n  .invoice-frame,\n  .invoice-sheet {\n    width: 100% !important;\n    min-height: 0 !important;\n    overflow: hidden !important;\n    border-radius: 0 !important;\n  }\n\n  .invoice-sheet {\n    display: block !important;\n  }\n\n  /* الهيدر — بانر كامل + محتوى مرتب فوقه بثلاث أعمدة */\n  .invoice-header-themed {\n    display: grid !important;\n    grid-template-columns: 1fr !important;\n    grid-template-rows: 1fr !important;\n    position: relative !important;\n    overflow: visible !important;\n    background: #0c1835 !important;\n    box-sizing: border-box !important;\n  }\n\n  .invoice-header-bg {\n    grid-column: 1 !important;\n    grid-row: 1 !important;\n    display: block !important;\n    width: 100% !important;\n    height: auto !important;\n    max-height: none !important;\n    object-fit: contain !important;\n    object-position: top center !important;\n    align-self: start !important;\n  }\n\n  .invoice-header-content {\n    grid-column: 1 !important;\n    grid-row: 1 !important;\n    position: relative !important;\n    inset: auto !important;\n    align-self: start !important;\n    width: 100% !important;\n    padding: 12px 12px 14px !important;\n    box-sizing: border-box !important;\n    overflow: visible !important;\n    z-index: 2 !important;\n    direction: rtl !important;\n\n    /* ═══ يمين ويسار الهيدر — عدّل هنا ═══ */\n    /* موضع الكتلة كاملة (شعار + نص تحته) */\n    --print-header-right-x: 60px;  /* يمين: سالب ← لليمين | موجب → للوسط */\n    --print-header-left-x: -60px;   /* يسار: سالب → لليسار | موجب ← للوسط */\n    --print-header-side-icon-size: 75px;\n    --print-header-side-icon-y: 10px;      /* رفع/نزول الأيقونة */\n    --print-header-side-icon-gap: 4px;\n    --print-header-side-text-size: 13px;\n    --print-header-side-text-line: 1.7;\n    --print-header-side-text-gap: 3px;\n\n    /* ═══ وسط الهيدر: شعار الشركة ═══ */\n    --print-company-logo-x: 0px;\n    --print-company-logo-y: 10px;\n  }\n\n  .invoice-header-row {\n    display: grid !important;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr) minmax(0, 1fr) !important;\n    align-items: start !important;\n    justify-content: stretch !important;\n    gap: 2px !important;\n    width: 100% !important;\n  }\n\n  .invoice-header-row > div {\n    display: flex !important;\n    flex-direction: column !important;\n    min-width: 0 !important;\n  }\n\n  /* يمين ويسار — الأيقونة فوق النص بالوسط (مو عند الحافة) */\n  .invoice-header-row > div:first-child,\n  .invoice-header-row > div:last-child {\n    justify-self: stretch !important;\n    align-items: center !important;\n    text-align: center !important;\n    margin-inline: 0 !important;\n  }\n\n  .invoice-header-row > div:first-child > div {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    width: 100% !important;\n    transform: translateX(var(--print-header-right-x)) !important;\n  }\n\n  .invoice-header-row > div:last-child > div {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    width: 100% !important;\n    transform: translateX(var(--print-header-left-x)) !important;\n  }\n\n  .invoice-header-row > div:nth-child(2) {\n    justify-self: center !important;\n    align-items: center !important;\n    text-align: center !important;\n  }\n\n  .invoice-header-row > div:nth-child(2) > .drop-shadow-sm {\n    display: flex !important;\n    justify-content: center !important;\n    width: 100% !important;\n    text-align: center !important;\n  }\n\n  .invoice-company-title {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    text-align: center !important;\n    width: 100% !important;\n  }\n\n  .invoice-company-office-row {\n    display: inline-flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    width: 100% !important;\n  }\n\n  .invoice-header-vision-slot,\n  .invoice-header-qr-slot {\n    display: flex !important;\n    justify-content: center !important;\n    align-self: center !important;\n    margin-inline: auto !important;\n    margin-bottom: var(--print-header-side-icon-gap) !important;\n    margin-top: var(--print-header-side-icon-y) !important;\n    transform: none !important;\n  }\n\n  .invoice-header-ksa-logo,\n  .invoice-header-qr-box {\n    width: var(--print-header-side-icon-size) !important;\n    height: var(--print-header-side-icon-size) !important;\n  }\n\n  .invoice-header-vision-slot {\n    transform: none !important;\n  }\n\n  .invoice-header-company-logo {\n    width: 140px !important;\n    height: 140px !important;\n    margin-inline: auto !important;\n    margin-bottom: 6px !important;\n    margin-top: var(--print-company-logo-y) !important;\n    transform: translateX(var(--print-company-logo-x)) !important;\n  }\n\n  .invoice-header-licenses,\n  .invoice-header-meta {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    align-self: center !important;\n    width: 100% !important;\n    margin-inline: 0 !important;\n    text-align: center !important;\n    transform: none !important;\n  }\n\n  .invoice-header-licenses .flex,\n  .invoice-header-meta .flex {\n    align-items: center !important;\n    text-align: center !important;\n  }\n\n  .invoice-header-licenses > * + *,\n  .invoice-header-meta > * + * {\n    margin-top: var(--print-header-side-text-gap) !important;\n  }\n\n  .invoice-header-licenses .invoice-license-label,\n  .invoice-header-meta .invoice-license-label {\n    font-size: var(--print-header-side-text-size) !important;\n    line-height: var(--print-header-side-text-line) !important;\n  }\n\n  .invoice-header-licenses .invoice-license-value,\n  .invoice-header-licenses .invoice-license-value span,\n  .invoice-header-meta .invoice-license-value,\n  .invoice-header-meta .invoice-license-value span {\n    font-size: var(--print-header-side-text-size) !important;\n    line-height: var(--print-header-side-text-line) !important;\n  }\n\n  .invoice-company-gold {\n    font-size: 25px !important;\n    font-weight: 700 !important;\n    line-height: 1.25 !important;\n    text-align: center !important;\n  }\n\n  .invoice-company-name {\n    font-size: 2rem !important;\n    font-weight: 700 !important;\n    line-height: 1.25 !important;\n    color: #111827 !important;\n    text-align: center !important;\n  }\n\n  .invoice-company-line {\n    width: 2rem !important;\n  }\n\n  .invoice-body-panel::before {\n    display: none !important;\n  }\n\n  .invoice-body-panel {\n    flex: none !important;\n    display: block !important;\n  }\n\n  .invoice-body {\n    padding: 10px 14px 12px !important;\n    background: transparent !important;\n  }\n\n  .invoice-section-block {\n    margin-bottom: 8px !important;\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  .invoice-section-title-row {\n    margin-bottom: 4px !important;\n  }\n\n  .invoice-section-title {\n    font-size: 0.9rem !important;\n  }\n\n  .invoice-title-icon-box {\n    width: 1.75rem !important;\n    height: 1.75rem !important;\n  }\n\n  .invoice-title-icon {\n    width: 1rem !important;\n    height: 1rem !important;\n  }\n\n  .invoice-section-frame {\n    padding: 6px 10px !important;\n    border: 1px solid #c9a227 !important;\n    background: transparent !important;\n  }\n\n  .invoice-stacked-field {\n    padding: 4px 6px !important;\n  }\n\n  .invoice-stacked-field span {\n    font-size: 0.75rem !important;\n    line-height: 1.25 !important;\n  }\n\n  .invoice-route-block {\n    padding: 6px 8px !important;\n  }\n\n  .invoice-route-row {\n    column-gap: 0.3rem !important;\n  }\n\n  .invoice-route-meta span,\n  .invoice-route-city {\n    font-size: 0.75rem !important;\n  }\n\n  .invoice-body .text-lg,\n  .invoice-body .text-base {\n    font-size: 0.8rem !important;\n    line-height: 1.3 !important;\n  }\n\n  .invoice-inner-divider {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n\n  .invoice-amount-row {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n\n  .invoice-amount-row span {\n    font-size: 0.8rem !important;\n  }\n\n  .invoice-footer {\n    padding-top: 6px !important;\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  .invoice-footer-grid {\n    display: grid !important;\n    grid-template-columns: 1fr 1px 1fr 1px 1fr !important;\n  }\n\n  .invoice-footer-cell {\n    font-size: 0.75rem !important;\n    padding-inline: 6px !important;\n  }\n\n  .invoice-footer-qr {\n    width: 4rem !important;\n    height: 4rem !important;\n  }\n\n  .invoice-container .invoice-license-label {\n    color: #b8860b !important;\n  }\n\n  .invoice-container .text-orange-600 {\n    color: #ea580c !important;\n  }\n\n  .invoice-title-icon,\n  .invoice-company-gold {\n    color: #c9a227 !important;\n  }\n\n  .invoice-company-name {\n    color: #111827 !important;\n  }\n\n  .invoice-company-line {\n    background: #c9a227 !important;\n  }\n\n  .invoice-footer {\n    border-top: 1px solid #c9a227 !important;\n  }\n\n  .invoice-footer-divider {\n    background: #c9a227 !important;\n  }\n\n  .invoice-container,\n  .invoice-container * {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  ::-webkit-scrollbar {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
